"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useOnTouchListener;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function useOnTouchListener(ref, events) {
  var _events = Object.assign({
    swiped: function swiped(e) {},
    swipedLeft: function swipedLeft(e) {},
    swipedRight: function swipedRight(e) {},
    swipedUp: function swipedUp(e) {},
    swipedDown: function swipedDown(e) {},
    customEvent: function customEvent(e) {}
  }, events);
  var xDown = null;
  var yDown = null;
  var xDiff = null;
  var yDiff = null;
  var timeDown = null;
  var startEl = null;
  var CustomEvent = function CustomEvent(event, params) {
    // if (!ref.current || ref.current.contains(event.target) || (onWebComponent && ref.current.contains(event.composedPath()[0]))) return;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
  var prepareCallbackListener = function prepareCallbackListener() {
    ref.current.addEventListener('swiped', _events.swiped);
    ref.current.addEventListener('swiped-left', _events.swipedLeft);
    ref.current.addEventListener('swiped-right', _events.swipedRight);
    ref.current.addEventListener('swiped-up', _events.swipedUp);
    ref.current.addEventListener('swiped-down', _events.swipedDown);
  };
  var removeCallbackListener = function removeCallbackListener() {
    ref.current.removeEventListener('swiped', function (e) {
      _events.swiped && _events.swiped(e);
    });
    ref.current.removeEventListener('swiped-left', function (e) {
      _events.swipedLeft && _events.swipedLeft(e);
    });
    ref.current.removeEventListener('swiped-right', function (e) {
      _events.swipedRight && _events.swipedRight(e);
    });
    ref.current.removeEventListener('swiped-up', function (e) {
      _events.swipedUp && _events.swipedUp(e);
    });
    ref.current.removeEventListener('swiped-down', function (e) {
      _events.swipedDown && _events.swipedDown(e);
    });
  };
  (0, _react.useEffect)(function () {
    if (!ref) return;
    var isExistCustomEvent = typeof window.CustomEvent !== 'function';
    if (isExistCustomEvent) window.CustomEvent.prototype = window.Event.prototype;

    // const container = ref.current
    ref.current.addEventListener('touchstart', handleTouchStart, false);
    ref.current.addEventListener('touchmove', handleTouchMove, false);
    ref.current.addEventListener('touchend', handleTouchEnd, false);
    prepareCallbackListener();
    return function () {
      ref.current.removeEventListener('touchstart', handleTouchStart);
      ref.current.removeEventListener('touchmove', handleTouchMove);
      ref.current.removeEventListener('touchend', handleTouchEnd);
      removeCallbackListener();
    };
  }, [ref, events]);
  function handleTouchEnd(e) {
    // if the user released on a different target, cancel!
    if (startEl !== e.target) return;
    var swipeThreshold = 20; // default 20px
    var swipeTimeout = 500; // default 500ms

    var timeDiff = Date.now() - timeDown;
    var eventType = '';
    var changedTouches = e.changedTouches || e.touches || [];
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      // most significant
      if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (xDiff > 0) {
          eventType = 'swiped-left';
        } else {
          eventType = 'swiped-right';
        }
      }
    } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
      if (yDiff > 0) {
        eventType = 'swiped-up';
      } else {
        eventType = 'swiped-down';
      }
    }
    if (eventType !== '') {
      var eventData = {
        dir: eventType.replace(/swiped-/, ''),
        touchType: (changedTouches[0] || {}).touchType || 'direct',
        xStart: parseInt(xDown, 10),
        xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
        yStart: parseInt(yDown, 10),
        yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
      };

      // fire `swiped` event event on the element that started the swipe
      startEl.dispatchEvent(new CustomEvent('swiped', {
        bubbles: true,
        cancelable: true,
        detail: eventData
      }));

      // fire `swiped-dir` event on the element that started the swipe
      startEl.dispatchEvent(new CustomEvent(eventType, {
        bubbles: true,
        cancelable: true,
        detail: eventData
      }));
    }
    xDown = null;
    yDown = null;
    timeDown = null;
  }
  function handleTouchStart(e) {
    // if the element has data-swipe-ignore="true" we stop listening for swipe _events
    if (e.target.getAttribute('data-swipe-ignore') === 'true') return;
    startEl = e.target;
    timeDown = Date.now();
    xDown = e.touches[0].clientX;
    yDown = e.touches[0].clientY;
    xDiff = 0;
    yDiff = 0;
  }
  function handleTouchMove(e) {
    if (!xDown || !yDown) return;
    var xUp = e.touches[0].clientX;
    var yUp = e.touches[0].clientY;
    xDiff = xDown - xUp;
    yDiff = yDown - yUp;
  }
}